/* Informational expiry only; never changes stock, forms or preorder controls. */
if (!customElements.get('ca-arrival-estimate')) {
  class CAArrivalEstimate extends HTMLElement {
    connectedCallback() {
      this.refresh = this.refresh.bind(this);
      this.selectionPending = false;
      this.isCard = this.dataset.compact === 'true';
      this.wrapper = this.closest('[data-ca-arrival-wrapper]');
      this.section = this.isCard ? null : this.closest('.shopify-section');
      this.onSelection = (event) => {
        if (!this.isCard && event.target.closest('variant-picker')) {
          this.selectionPending = true;
          this.hideEstimate();
        }
      };
      this.section?.addEventListener('change', this.onSelection, true);
      document.addEventListener('visibilitychange', this.refresh);
      window.addEventListener('focus', this.refresh);
      this.placementRoot = this.isCard ? null : this.closest('.product-info__block');
      this.placeBeforeNotify = () => {
        if (this.selectionPending || !this.wrapper || !this.placementRoot) return;
        const inline = this.placementRoot.querySelector('#restock-rocket-inline-container');
        if (inline && inline.previousElementSibling !== this.wrapper) {
          inline.before(this.wrapper);
        }
      };
      if (this.placementRoot) {
        this.placementObserver = new MutationObserver(this.placeBeforeNotify);
        this.placementObserver.observe(this.placementRoot, { childList: true, subtree: true });
      }
      this.refresh();
      this.placeBeforeNotify();
    }
    disconnectedCallback() {
      clearTimeout(this.timer);
      this.placementObserver?.disconnect();
      this.section?.removeEventListener('change', this.onSelection, true);
      document.removeEventListener('visibilitychange', this.refresh);
      window.removeEventListener('focus', this.refresh);
    }
    hideEstimate() {
      clearTimeout(this.timer);
      this.hidden = true;
      this.style.display = 'none';
      if (this.wrapper) this.wrapper.hidden = true;
    }
    refresh() {
      clearTimeout(this.timer);
      if (this.selectionPending) { this.hideEstimate(); return; }
      const now = Date.now();
      const source = Date.parse(this.dataset.sourceAsof);
      const expiry = Date.parse(this.dataset.expiresAt);
      const start = Date.parse(this.dataset.startDate + 'T00:00:00+08:00');
      const end = Date.parse(this.dataset.endDate + 'T23:59:59+08:00');
      const until = Math.min(expiry, source + 48 * 60 * 60 * 1000, end);
      if (![source, expiry, start, end].every(Number.isFinite) || source > now || start > end || until <= now) {
        this.hideEstimate();
        return;
      }
      this.hidden = false;
      if (this.wrapper) this.wrapper.hidden = false;
      this.style.removeProperty('display');
      this.timer = setTimeout(this.refresh, Math.min(until - now, 60000));
    }
  }
  customElements.define('ca-arrival-estimate', CAArrivalEstimate);
}
